$(window).load(function() {
    $('#loading').fadeOut('300', function() {
       $(this).remove();
    });
});

$(document).ready(function(){
    "use strict";
    
    var $navbar = $('#header-nav');
    var $navbarTrigger = $('#navbar-trigger');
    var $mainNav = $('#header-menu');
    var $magicLine = $('#magic-line');
    var navbarFixedHeight = 75;
    
    if(!getCookie('transport-kubacki-approval')){
        $('#cookie-policy').show();
    }

    $('#cookie-policy a').click(function(e){
        e.preventDefault();
        setCookie('transport-kubacki-approval',true, 60);
        $('#cookie-policy').fadeOut('100');
    });
    
    $navbarTrigger.click(function() {
        $navbar.toggleClass('navbar-active');
    });
    
    $(window).on('scroll touchmove', function(e){
        var actualScrollTop = $(this).scrollTop();
        if(actualScrollTop >= 150){
            $navbar.addClass('navbar-fixed');
        }else
        {
            $navbar.removeClass('navbar-fixed');
        }
    });
    
    $(window).on('load resize orientationchange', function (){
        $magicLine
            .css({
                left: $mainNav.find('.active a').position().left + ($mainNav.find('.active a').width() - 40)*0.5,
                opacity: 1
            })
            .data('origLeft', $magicLine.position().left);
        $mainNav.find('li a').hover(function() {
            $magicLine.stop().animate({
                left: $(this).position().left  + ($(this).width() - 40)*0.5
            }, 100);
        }, function() {
            $magicLine.stop().animate({
                left: $magicLine.data('origLeft')
            }, 300);    
        });
    });
    
    $('.scroll-to').each(function(){
        $(this).on('click', function(e){
            e.preventDefault();
            if($navbar.is('.navbar-active')){
                $navbar.removeClass('navbar-active');
            }
            $('html, body').animate({
                scrollTop:  $($(this).attr('href')).offset().top - navbarFixedHeight
            }, 1000);
            
        });
    });
    
    var aArray = [];
    
    $navbar.find('.scroll-to').each(function(){
        var ahref = $(this).attr('href');
        aArray.push(ahref);
    });
    
    $(window).on('scroll', function() {
        var windowPos = $(window).scrollTop();
        for (var i = 0; i < aArray.length; i++) {
            var theID = aArray[i];
            var secPosition = $(theID).offset().top - navbarFixedHeight - 1;
            var divHeight = $(theID).outerHeight();
            if (windowPos > secPosition && windowPos <= (secPosition + divHeight)) {
                var newLeft = $navbar.find(".scroll-to[href='" + theID + "']").position().left + ($navbar.find(".scroll-to[href='" + theID + "']").width() - 40)*0.5;
                $navbar.find(".scroll-to[href='" + theID + "']").parent().addClass('active');
                $magicLine.stop().animate({
                    left: newLeft
                }, 200).data('origLeft', newLeft);
            } else {
                $navbar.find(".scroll-to[href='" + theID + "']").parent().removeClass('active');
            }
        }
    });
    
    if($('.start-slider').length){
        $('.start-slider').slick({
            arrows: true,
            dots: true,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 6000,
            fade: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: false,
            adaptiveHeight: true,
            swipe: true
        });
    }

    if($('.gallery-slider').length){
        $('.gallery-slider').slick({
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable: false,
            adaptiveHeight: true,
            swipe: true,
            responsive: [{
                breakpoint: 1200,
                settings: {
                  slidesToShow: 2,
                }
              }, {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                }
              }]
        });
        $('.gallery-slider').slickLightbox({
            src: 'data-img-origin',
            itemSelector: '.slide'
        });
    }
    
    $(window).on('load scroll touchmove', function(){
        doAnimations();
    });
        
});

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
    }
    return "";
}

function doAnimations() {
	var offset = $(window).scrollTop() + $(window).height();
	$('.animatable').each(function(i) {
	    var $animatable = $(this);
		if ($animatable.offset().top + 150 <offset || $animatable.offset().top < $(window).height()) {
	       	$animatable.removeClass('animatable').addClass('animated');
		} 
	});
}
